export default "__VITE_ASSET__kKRP4CrZ__"